import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { Button } from "./button.component";
import { Loader } from "./loader.component";
import { Modal } from "./modal.component";

function ActionModalComponent({
  onSubmit,
  title,
  header,
  isLoading,
  btnColor,
  active = false,
  setActive = (e) => {},
  userName,
}) {
  const resetFormAndClose = () => {
    setActive(false);
  };

  // if (!activeGroup || !active) {
  //     return <></>;
  // }

  return (
    <Modal
      className="CreateGroupModal"
      active={active}
      width="390px"
      padding={false}
      setActive={setActive}>
      {/* headers */}
      <div className="pl-4 pr-2 py-2 flex items-center justify-between">
        <span className="font-bold text-gray-700">{header}</span>
        {/* <IconButton icon={plusGrayIcon} rotate={45} onClick={
                    () => {
                        resetFormAndClose();
                    }
                } /> */}
      </div>
      <div className="pl-4 pr-2 py-2 ">
        <p className="font-bold text-gray-700 overflow-x-auto">
          {userName ? userName : ""}
        </p>
      </div>
      {/* body */}
      <div className="p-5 text-gray-700 pt-2">
        <div className="font-bold">{title}</div>
        <div className="mt-5">
          <div className="mx-auto">
            {isLoading ? (
              <div className="flex justify-center">
                <Loader />
              </div>
            ) : (
              <div className="flex justify-center">
                <Button
                  // disabled={!isFormSubmitable}
                  onClick={resetFormAndClose}
                  className="mr-2 p-4 w-full"
                  label="Cancel"
                  large
                />
                <Button
                  // disabled={!isFormSubmitable}
                  onClick={onSubmit}
                  btnColor={btnColor}
                  className="p-4 w-full"
                  label="Delete"
                  large
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
}

const ActionModal = ActionModalComponent;

export { ActionModal };
